var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketSnooze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4982_1235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#C6E8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5784 16.8387C13.3497 16.8387 14.0719 16.6613 14.7451 16.3065C15.4183 15.9516 16.0098 15.4839 16.5196 14.9032C14.8333 14.8 13.3954 14.1839 12.2059 13.0548C11.0163 11.9258 10.4216 10.5419 10.4216 8.90323C10.4216 8.68387 10.4379 8.46129 10.4706 8.23548C10.5033 8.00968 10.5392 7.7871 10.5784 7.56774C9.72876 8.03226 9.03268 8.65161 8.4902 9.42581C7.94771 10.2 7.67647 11.0581 7.67647 12C7.67647 13.3441 8.15305 14.4866 9.10622 15.4274C10.0594 16.3683 11.2168 16.8387 12.5784 16.8387ZM12.5784 18C10.8922 18 9.45752 17.4161 8.27451 16.2484C7.0915 15.0806 6.5 13.6645 6.5 12C6.5 10.3355 7.0915 8.91935 8.27451 7.75161C9.45752 6.58387 10.8922 6 12.5784 6C12.2386 6.4129 11.9902 6.86774 11.8333 7.36452C11.6765 7.86129 11.598 8.37419 11.598 8.90323C11.598 10.2473 12.0746 11.3898 13.0278 12.3306C13.9809 13.2715 15.1383 13.7419 16.5 13.7419C16.8399 13.7419 17.1797 13.7065 17.5196 13.6355C17.8595 13.5645 18.1863 13.4581 18.5 13.3161C18.1863 14.6839 17.4771 15.8065 16.3726 16.6839C15.268 17.5613 14.0033 18 12.5784 18Z",
    fill: "#12445A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7H17.35L14.5 11H17.5",
    stroke: "#12445A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4982_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSnooze);
export default __webpack_public_path__ + "static/media/ticket-snooze.10f502f7359e3dcb553b8d3f621535b4.svg";
export { ForwardRef as ReactComponent };